import React from "react";
import _ from "lodash";
import numeral from "numeral";
import Checkbox from "components/common/Checkbox";
import {
  parseTableData,
  filterDataToGroup,
} from "../IntegrationVerificationHelper";
import GroupDataTable from "./GroupDataTable";
import FilterControl from "./FilterControl";

class ServingRestrictionRequestView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tabsObj: {},
      hideUmObj: {},

      expression: "",
      filterGroups: [],
      filterRecords: [],
      filterAmount: null,

      isHideUm: true,
      tags: [],
      alias: [],
      hideUmTags: [],
    };

    this.handleSearch = this.handleSearch.bind(this);
  }

  componentDidMount() {
    const { records, columns } = this.props;

    const indexColumns = [
      columns[0],
      columns[1],
      "serving_restriction",
      "b_request",
      "o_request",
      "um_request",
      "total_request",
    ];

    const indexHideUmColumns = [
      ...indexColumns.slice(0, 5),
      ...indexColumns.slice(6),
    ];

    const arrangeColumns = [
      {
        key: "ext_gam_unit_id",
        label: "Ext Gam Unit Id",
        groupfunc: (list) => {
          const temp = _.union(list);
          return temp.length > 1 ? "--" : temp[0];
        },
      },
      {
        key: "date",
        label: "Date",
        groupfunc: (list) => {
          const temp = _.union(list);
          return temp.length > 1 ? "--" : temp[0];
        },
      },
      {
        key: "serving_restriction",
        label: "Serving Restriction",
        groupfunc: (list) => {
          const temp = _.union(list);
          return temp.length > 1 ? "--" : temp[0];
        },
      },
      {
        key: "total_request",
        label: "total req #",
        groupfunc: (list) => {
          return _.sum(_.filter(list, (d) => _.isNumber(d)));
        },
        format: (val) => {
          return numeral(val).format("0,0");
        },
        align: "text-right",
      },
      {
        key: "b_request",
        label: "req #",
        group: "b",
        groupfunc: (list) => {
          return _.sum(_.filter(list, (d) => _.isNumber(d)));
        },
        format: (val) => {
          return numeral(val).format("0,0");
        },
        align: "text-right",
      },
      {
        key: "b_request_percent",
        label: "req %",
        group: "b",
        parsefunc: ({ b_request, total_request }) => {
          return total_request === 0 || b_request === "-"
            ? 0
            : b_request / total_request;
        },
        format: (val) => {
          return numeral(val).format("0.00%");
        },
      },
      {
        key: "o_request",
        label: "req #",
        group: "o",
        groupfunc: (list) => {
          return _.sum(_.filter(list, (d) => _.isNumber(d)));
        },
        format: (val) => {
          return numeral(val).format("0,0");
        },
        align: "text-right",
      },
      {
        key: "o_request_percent",
        label: "req %",
        group: "o",
        parsefunc: ({ total_request, o_request }) => {
          return total_request === 0 || o_request === "-"
            ? 0
            : o_request / total_request;
        },
        format: (val) => {
          return numeral(val).format("0.00%");
        },
      },
      {
        key: "um_request",
        label: "req #",
        group: "um",
        groupfunc: (list) => {
          return _.sum(_.filter(list, (d) => _.isNumber(d)));
        },
        format: (val) => {
          return numeral(val).format("0,0");
        },
        align: "text-right",
      },
      {
        key: "um_request_percent",
        label: "req %",
        group: "um",
        parsefunc: ({ total_request, um_request }) => {
          return total_request === 0 || um_request === "-"
            ? 0
            : um_request / total_request;
        },
        format: (val) => {
          return numeral(val).format("0.00%");
        },
      },
    ];

    const arrangeHideUmColumns = arrangeColumns.slice(0, 8);

    const dateIdx = _.indexOf(columns, "date");
    const idIdx = _.indexOf(columns, "ext_gam_unit_id");
    const groupIdx = _.indexOf(columns, "group_type");
    const reqIdx = _.indexOf(columns, "request_v2");
    const tabIdx = _.indexOf(columns, "serving_restriction");

    const newRecords = [];
    const hideUmRecords = [];
    _.forEach(records, (item) => {
      const date = item[dateIdx];
      const id = item[idIdx];
      const group = item[groupIdx];
      const req = item[reqIdx];
      const tab = item[tabIdx];

      let index = _.findIndex(newRecords, (record) => {
        return record[0] === date && record[1] === id && record[2] === tab;
      });

      if (index < 0) {
        newRecords.push([date, id, tab, 0, 0, 0, 0]);
        hideUmRecords.push([date, id, tab, 0, 0, 0]);
        index = newRecords.length - 1;
      }

      if (group === "b") {
        newRecords[index][3] += req;
        hideUmRecords[index][3] += req;
      } else if (group === "o") {
        newRecords[index][4] += req;
        hideUmRecords[index][4] += req;
      } else if (group === "um") {
        newRecords[index][5] += req;
      }
      newRecords[index][6] += req;
      if (group !== "um") {
        hideUmRecords[index][5] += req;
      }
    });

    const tabsObj = parseTableData({
      columns: indexColumns,
      arrangeColumns: arrangeColumns,
      records: newRecords,
      mainKey: "ext_gam_unit_id",
      subKey: "date",
      orderKey: "total_request",
    });

    const hideUmObj = parseTableData({
      columns: indexHideUmColumns,
      arrangeColumns: arrangeHideUmColumns,
      records: hideUmRecords,
      mainKey: "ext_gam_unit_id",
      subKey: "date",
      orderKey: "total_request",
    });

    this.setState(
      {
        tabsObj: {
          ...tabsObj,
          arrangeColumns,
        },
        hideUmObj: {
          ...hideUmObj,
          arrangeColumns: arrangeHideUmColumns,
        },
        tags: [
          {
            value: "serving_restriction",
            label: "Serving Restriction",
            type: "string",
          },
          ...arrangeColumns.slice(3).map((item) => ({
            value: item.key,
            label: item.label,
            group: item.group,
          })),
        ],
        alias: [
          {
            value:
              "total_request >= 10000 AND ( o_request_percent <= 0.88 OR o_request_percent >= 0.92)",
            label: "Quick Filter",
          },
          {
            func: (inputValue) =>
              `total_request >= 10000 AND ( o_request_percent <= ${(
                inputValue - 0.02
              ).toFixed(2)} OR o_request_percent >= ${(
                inputValue + 0.02
              ).toFixed(2)})`,
            label: "Custom O Request %",
          },
        ],

        hideUmTags: [
          {
            value: "serving_restriction",
            label: "Serving Restriction",
            type: "string",
          },
          ...arrangeHideUmColumns.slice(3).map((item) => ({
            value: item.key,
            label: item.label,
            group: item.group,
          })),
        ],
      },
      () => {
        this.handleSearch();
      }
    );
  }

  // Cause isHideUm flag need to exec filter data first
  handleSearch(expression = this.state.expression) {
    const { tabsObj, hideUmObj, isHideUm } = this.state;
    const { records, arrangeColumns } = isHideUm ? hideUmObj : tabsObj;

    const result = filterDataToGroup({
      expression,
      records,
      columns: arrangeColumns,
      hasSubGroup: true,
    });

    if (result) {
      this.setState({
        expression,
        ...result,
      });
    }
  }

  render() {
    const {
      hideUmObj,
      tabsObj,
      isHideUm,
      tags,
      alias,
      hideUmTags,
      filterAmount,
      filterGroups,
      filterRecords,
    } = this.state;

    const dataObj = isHideUm ? hideUmObj : tabsObj;
    const dataTags = isHideUm ? hideUmTags : tags;

    if (_.keys(dataObj).length === 0) {
      return null;
    }

    const { arrangeColumns } = dataObj;

    const header = isHideUm ? (
      <tr className="bg-gray-100">
        <th className="border px-2 py-1 text-center" colSpan={6}></th>
        <th className="border px-2 py-1 text-center" colSpan={2}>
          b
        </th>
        <th className="border px-2 py-1 text-center" colSpan={2}>
          o
        </th>
      </tr>
    ) : (
      <tr className="bg-gray-100">
        <th className="border px-2 py-1 text-center" colSpan={6}></th>
        <th className="border px-2 py-1 text-center" colSpan={2}>
          b
        </th>
        <th className="border px-2 py-1 text-center" colSpan={2}>
          o
        </th>
        <th className="border px-2 py-1 text-center" colSpan={2}>
          um
        </th>
      </tr>
    );

    return (
      <>
        <div className="relative mb-2">
          <FilterControl
            tags={dataTags}
            alias={alias}
            handleSearch={this.handleSearch}
          ></FilterControl>

          <div
            className="absolute right-0 flex items-center gap-1"
            style={{ top: "0.75rem" }}
          >
            <Checkbox
              isChecked={isHideUm}
              onChange={(value) =>
                this.setState({ isHideUm: value }, () => {
                  this.handleSearch();
                })
              }
            ></Checkbox>
            <span className="text-sm font-semibold text-gray-600 hover:text-gray-700">
              Hide um
            </span>
          </div>
        </div>
        <GroupDataTable
          records={filterRecords}
          groups={filterGroups}
          amount={filterAmount}
          mainKey="ext_gam_unit_id"
          subKey="date"
          columns={arrangeColumns}
          header={header}
        ></GroupDataTable>
      </>
    );
  }
}
export default ServingRestrictionRequestView;
